import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography } from "@material-ui/core";
import { MovementResult } from "./MovementResult";

export const MovementResults = ({ results, classes }) => {
	const translate = useTranslate();

	if (!results || results.length === 0) {
		return (
			<Box className={classes.noResults}>
				<Typography>{translate("resources.storage-transactions.dialogs.no_movement_results")}</Typography>
			</Box>
		);
	}

	return (
		<Box className={classes.resultsSection}>
			{results.map((result, index) => (
				<MovementResult key={index} result={result} classes={classes} />
			))}
		</Box>
	);
};
